import { Table } from "antd";
import { useTranslation } from "react-i18next";
import { useEffect, useMemo, useState } from "react";
import { usePagination } from "datastake-daf/dist/hooks";
import TableFilters from "./tableFilters";
import { emptyDataSource } from './config';
import TablePagination from "../../Table/pagination";
import { isEmptyOrSpaces } from "../../../helpers/StringHelper";
import { getLocales } from "../../Table/newTable";

export default function ProjectsTab({
  columns = [],
  projects = [],
  perPage = 10,
}) {
  const { t } = useTranslation();
  const [activeFilters, setActiveFilters] = useState({});
  const [search, setSearch] = useState('');

  const _projects = useMemo(() => {
    let _filtered = projects;

    if (!isEmptyOrSpaces(search)) {
      _filtered = _filtered.filter((v) => (v.name || '').toLowerCase().indexOf(search.toLowerCase()) !== -1);
    }

    if (activeFilters.country) {
      _filtered = _filtered.filter((v) => v.country === activeFilters.country);
    }

    if (activeFilters.projectId) {
      _filtered = _filtered.filter((v) => v.projectId === activeFilters.projectId);
    }

    return _filtered;
  }, [search, activeFilters, projects]);

  const total = useMemo(() => _projects.length, [_projects]);

  const {
    goPrev,
    goNext,
    canGoNext,
    canGoPrev,
    page,
    setPage,
  } = usePagination({ total, perPage });

  const _filtered = useMemo(() => {
    const toReturn = _projects.slice((page - 1) * perPage, page * perPage)
    return emptyDataSource.map((empty, i) => toReturn[i] || empty);
  }, [_projects, page, perPage]);

  const filtersInit = useMemo(() => {
    const projectIds = projects.map((p) => ({
      value: p.projectId,
      label: p.projectId,
    }));

    return [
      {
        items: projectIds,
        key: 'projectId',
        label: 'Project ID',
        optionsName: 'projectId',
        placeholder: `${t('Select')} ${t('Project ID')}`,
        type: 'select',
      },
    ];
  }, [projects, t])

  useEffect(() => {
    setPage(1);
  }, [activeFilters, search]);

  return (
    <>
      <TableFilters
        setActiveFilters={setActiveFilters}
        t={t}
        search={search}
        setSearch={setSearch}
        filtersInit={filtersInit}
      />
      <div className="daf-table-wrapper">
        <Table
          locale={getLocales(t)}
          rowSelection={null}
          columns={columns.filter(c => {
            return c.projects !== false
          })}
          dataSource={_filtered}
          size="small"
          rowKey="projectId" />
        <TablePagination
          t={t}
          page={page}
          totalPages={total}
          goPrev={goPrev}
          goNext={goNext}
          canGoNext={canGoNext}
          canGoPrev={canGoPrev}
          loaded
          totalItems={total}
          doTotalItems
          perPage={perPage}
        />
      </div>
    </>
  )
}
